import { render, staticRenderFns } from "./RollDice.vue?vue&type=template&id=e6cf0378&scoped=true&"
import script from "./RollDice.vue?vue&type=script&lang=js&"
export * from "./RollDice.vue?vue&type=script&lang=js&"
import style0 from "./RollDice.vue?vue&type=style&index=0&id=e6cf0378&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6cf0378",
  null
  
)

export default component.exports